
import React from "react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

interface ProjectHandlersProps {
  user: any;
  onProjectCreated: (projectId: string) => Promise<string>;
}

export const useProjectHandlers = ({ user, onProjectCreated }: ProjectHandlersProps) => {
  const handleCreateProject = async (name: string) => {
    if (!user) {
      toast.error("Du måste vara inloggad för att skapa projekt");
      return;
    }

    try {
      console.log("Creating project with name:", name);
      
      // Create the project
      const { data: project, error: projectError } = await supabase
        .from('projects')
        .insert({
          name: name,
          user_id: user.id,
          description: `Projekt skapat ${new Date().toLocaleDateString()}`
        })
        .select()
        .single();

      if (projectError) {
        console.error("Project creation error:", projectError);
        throw projectError;
      }

      console.log("Project created successfully:", project);

      // Automatically select the new project
      await onProjectCreated(project.id);

      toast.success(`Projekt "${name}" skapat!`, {
        description: "Du kan nu skapa mappar och börja organisera dina riskbedömningar.",
        duration: 5000
      });

    } catch (error: any) {
      console.error("Error creating project:", error);
      toast.error("Kunde inte skapa projektet", {
        description: error.message || "Ett oväntat fel uppstod",
        duration: 5000
      });
    }
  };

  return { handleCreateProject };
};
